export default "__VITE_ASSET__jgLs8mU$__"